module.exports = __webpack_public_path__ + "static/media/Yolanda.f52fb6dc.jpg";